import { render, staticRenderFns } from "./HeroLoader.vue?vue&type=template&id=d9d3d1a4&"
import script from "./HeroLoader.vue?vue&type=script&lang=js&"
export * from "./HeroLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeroLoader.vue"
export default component.exports